import React from "react";
import { ArrowUpRight } from "lucide-react";
import CopyEmailButton from "./CopyEmailButton";
import Panot from "./Panot";
import { trackAction } from "./PageAnalytics";
import {
  CONTACT_EMAIL,
  CONTACT_MAILTO,
  CV_DOWNLOAD_FILENAME,
  CV_DOWNLOAD_URL,
  socialLinks,
} from "../../data/portfolioWork";

// The one footer, on every page, which is also Contact: the address (a
// mailto) with a quiet copy action, the profiles and the CV as plain links,
// and the copyright. The heading is for assistive tech, so the footer is a
// named landmark. On the homepage it is the #contact anchor target. The page
// ends on a strip of Barcelona pavement, decoration only.

function ExternalLink({ href, label, track }) {
  return (
    <a
      href={href}
      className="pf-foot__link"
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackAction("open_profile", track)}
    >
      <span>
        {label}
        <span className="pf-visually-hidden"> (opens in a new tab)</span>
      </span>
      <ArrowUpRight size={16} strokeWidth={1.75} aria-hidden="true" />
    </a>
  );
}

function Footer({ id, className = "" }) {
  const year = new Date().getFullYear();
  const linkedIn = socialLinks.find((link) => link.label === "LinkedIn");
  const others = socialLinks.filter((link) => link.external && link !== linkedIn);
  const headingId = id ? `${id}-heading` : "footer-heading";

  return (
    <footer
      id={id}
      tabIndex={id ? -1 : undefined}
      className={`pf-foot pf-shell ${className}`.trim()}
      aria-labelledby={headingId}
    >
      <h2 id={headingId} className="pf-visually-hidden">
        Contact
      </h2>
      <div className="pf-foot__row">
        <div className="pf-foot__email">
          <a
            href={CONTACT_MAILTO}
            className="pf-foot__address"
            onClick={() => trackAction("mailto", "contact")}
          >
            {CONTACT_EMAIL}
          </a>
          <CopyEmailButton source="contact" variant="quiet" />
        </div>
        <ul className="pf-foot__links">
          {linkedIn && (
            <li>
              <ExternalLink href={linkedIn.href} label={linkedIn.label} track="linkedin" />
            </li>
          )}
          <li>
            <a
              href={CV_DOWNLOAD_URL}
              download={CV_DOWNLOAD_FILENAME}
              className="pf-foot__link"
              onClick={() => trackAction("download_cv", "contact")}
            >
              <span>
                <span className="pf-visually-hidden">Download </span>CV
                <span className="pf-visually-hidden"> (PDF)</span>
              </span>
            </a>
          </li>
          {others.map((link) => (
            <li key={link.label}>
              <ExternalLink
                href={link.href}
                label={link.label}
                track={link.label.toLowerCase()}
              />
            </li>
          ))}
        </ul>
        <p className="pf-foot__legal">© {year} Oscar Rabadán Fuertes</p>
      </div>
      <Panot id="pf-panot-foot" className="pf-foot__pavement" />
    </footer>
  );
}

export default Footer;
